export function getInterchangeFee(category, agentChannelRaw) {
  // detect channel type from the raw string
  const channel = agentChannelRaw?.toLowerCase().includes("agt")
    ? "agt"
    : agentChannelRaw?.toLowerCase().includes("mob")
    ? "mob"
    : agentChannelRaw?.toLowerCase().includes("int")
    ? "int"
    : "other";

  switch (category.toLowerCase()) {
    case "electricity":
    case "gas":
    case "water":
    case "donation":
      return `₹2.25`;

    case "mobile postpaid":
    case "landline postpaid":
    case "broadband postpaid":
    case "cable tv":
      return channel === "agt" ? "₹5" : "₹2.5";

    case "loan repayment":
      if (channel !== "agt") {
        return "₹5";
      } else {
        return "₹5 or 0.3% of T.V. (whichever is higher)";
      }

    case "recurring deposit":
    case "mutual fund":
      return "₹5";

    case "lpg gas":
      return "₹1.1";

    case "municipal taxes":
    case "municipal services":
      return "T.V. <= 5000: ₹2.25 | T.V. > 5000: ₹5";

    case "credit card":
      return "₹2.5";

    case "insurance":
      return "T.V. <= 5000: ₹5 | T.V. > 5000: ₹10";

    case "education fees":
    case "education":
      return "T.V. <= 5000: ₹3 | T.V. > 5000 to 10,000: ₹5 | T.V. > 10,000 to 49,999: ₹10 | T.V. >= 50,000: ₹20";

    case "housing society":
    case "hospital":
    case "pathology":
    case "clubs and associations":
    case "rental":
      return "T.V. <= 10,000: ₹5 | T.V. > 10,000 to 49,999: ₹10 | T.V. >= 50,000: ₹20";

    case "fastag":
      return channel === "agt" ? "0.25% of T.V." : "0.15% of T.V.";

    case "metro recharge":
      return "0.50% of T.V.";

    case "ncmc":
      return "₹0.6";

    case "nps":
      return "₹0.4";

    case "prepaid meters":
      return "₹3";

    default:
      return "Not Found";
  }
}

export function getSwitchingFee(category) {
  switch (category.trim().toLowerCase()) {
    // 0.03% categories
    case "mobile prepaid recharges":
    case "dth":
    case "fastag":
    case "metro recharge":
    case "subscription fees":
      return "0.03% of transaction value";

    // 0.30% categories
    case "electricity":
    case "lpg gas":
    case "cng gas":
    case "water":
    case "municipal taxes":
    case "municipal services":
    case "landline postpaid":
    case "mobile postpaid":
    case "cable tv":
    case "broadband/ datacard":
    case "b2b payments (generic)":
      return "₹0.30";

    // 0.50% categories
    case "insurance":
    case "loan repayment":
    case "recurring deposit":
    case "mutual fund":
    case "credit card":
    case "housing society":
    case "education fees":
    case "hospital":
    case "pathology":
    case "clubs and associations":
    case "rental":
      return "₹0.50";

    default:
      return "Not Found";
  }
}
